module.exports = __webpack_public_path__ + "img/share-financials.1bb77ba3.svg";